import Content from "./index.vue"
import SettingsUsers from "./SettingsUsers.vue"
import SettingsMyProfile from "./SettingsMyProfile"
import SettingsLibraries from "./SettingsLibraries"
import SettingsMyPermissions from './SettingsMyPermissions';
import SettingsRoles from './settingsRoles';
export default {
	name: 'Settings',
	path: 'settings',
	component: Content,
	meta: {
		breadCrumb: 'Control Panel'
	},
	children: [
		{
			name: 'Site Libraries',
			path: 'libraries',
			component: SettingsLibraries
		},
		{
			name: 'My Profile',
			path: 'profile',
			component: SettingsMyProfile
		},
		{
			name: 'Site Users',
			path: 'users',
			component: SettingsUsers
		},
		{
			name: 'My Permissions',
			path: 'permissions',
			component: SettingsMyPermissions
		},
		{
			name: 'Site Roles',
			path: 'roles',
			component: SettingsRoles
		}
	]
};
